import React from 'react';
import { RedirectToSignIn } from '@clerk/clerk-react';
import { LoadingSpinner } from './LoadingSpinner';
import { useHashRouter } from '../hooks/useHashRouter';
import { isAdmin } from '../utils/admin';
import { useAuth } from '../hooks/useAuth';

interface AdminGateProps {
    children: React.ReactNode;
}

export const AdminGate: React.FC<AdminGateProps> = ({ children }) => {
    const { isLoaded, isSignedIn, user } = useAuth();
    const { navigate } = useHashRouter();

    if (!isLoaded) {
        return <LoadingSpinner />;
    }

    if (!isSignedIn) {
        return <RedirectToSignIn />;
    }

    if (!isAdmin(user)) {
        return (
            <div className="min-h-screen flex items-center justify-center p-4 transition-colors">
                <div className="max-w-md w-full bg-white dark:bg-stone-900 p-8 rounded-3xl border border-stone-200 dark:border-stone-800 text-center shadow-xl">
                    <div className="w-20 h-20 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-6 text-red-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>
                    </div>
                    <h1 className="text-2xl font-bold mb-3 text-stone-900 dark:text-white">Prístup zamietnutý</h1>
                    <p className="text-stone-500 dark:text-stone-400 mb-8 leading-relaxed">
                        Váš účet (<strong>{user?.email}</strong>) nemá oprávnenia administrátora.
                    </p>
                    <button
                        onClick={() => navigate('/')}
                        className="w-full bg-stone-900 dark:bg-stone-800 hover:bg-stone-800 dark:hover:bg-stone-700 text-white font-bold py-3.5 px-6 rounded-xl transition-all"
                    >
                        Späť na hlavnú stránku
                    </button>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};
